import { env } from '../../../../config/global'
import { token } from '../../../../config/access-token'

class UploadAdapter {
    constructor(loader) {
        this.url = env.service_url;
        this.domain = env.service_url;
        this.loader = loader;
    }

    upload() {
        return this.loader.file.then(file => new Promise((async (resolve, reject) => {
                const form_data = new FormData();
                form_data.append('upload_path', 'ckedittor/')
                form_data.append('files', file)
                const res_upload = await fetch(`${this.url}file-upload/uploadFile`, {
                    method: 'post',
                    headers: {
                      'x-access-token': token['x-access-token'],
                    },
                    body: form_data
                }).then((response) => response.json().then((responseJson) => {
                    return responseJson
                })).catch((error) => {
                    return { require: false, data: [], err: error }
                })
                resolve({
                    default: this.domain + res_upload.data.file_name 
                })
            })))
    }
}
export default UploadAdapter;